(function (Cobalt) {
    var $ = jQuery;
    var MurmurHash2 = /** @class */ (function () {
        function MurmurHash2() {
        }
        // Based on MIT-licensed JavaScript implementation by Gary Court, https://github.com/mikolalysenko/murmurhash-js
        MurmurHash2.compute = function (buffer) {
            var input = new Uint8Array(buffer), l = input.length, h = MurmurHash2.seed ^ l, i = 0, k = 0;
            while (l >= 4) {
                k =
                    ((input[i] & 0xff)) |
                    ((input[++i] & 0xff) << 8) |
                    ((input[++i] & 0xff) << 16) |
                    ((input[++i] & 0xff) << 24);
                k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));
                k ^= k >>> 24;
                k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));
                h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;
                l -= 4;
                ++i;
            }
            switch (l) {
                case 3: h ^= (input[i + 2] & 0xff) << 16;
                case 2: h ^= (input[i + 1] & 0xff) << 8;
                case 1:
                    h ^= (input[i] & 0xff);
                    h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
            }
            h ^= h >>> 13;
            h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
            h ^= h >>> 15;
            return h >>> 0;
        };
        MurmurHash2.seed = 1;
        return MurmurHash2;
    }());
    Cobalt.MurmurHash2 = MurmurHash2;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.MurmurHash2.js